import { useState, useEffect, useRef } from "react";
import useOutsideClick from "./close_modal_outside_click";
import { rightOpenBigIcon, leftOpenBigIcon } from '@/lib/icons.js';

export default function Lightbox(props) {
  const [imageToShow, setImageToShow] = useState(null);
  const [index, setIndex] = useState(props.index);
  const lightBoxRef = useRef();

  useOutsideClick(lightBoxRef, () => {
    props.hideLightBox();
  });

  const show = (e, index) => {
    e.stopPropagation();
    setIndex(index);
    showImage(props.images[index]);
  }

  const showImage = (image) => {
    setImageToShow(image);
    document.body.style.overflow = "hidden";
  }


  useEffect(() => {
    setIndex(props.index);
    if(props.index != null)
      showImage(props.images[props.index]);
  }, [props.index])

  return (    
    <div className="lightbox" style={{ display: (index != null) ? 'flex': 'none' }}>
      { imageToShow && <button className="lightbox-close" onClick={() => {props.hideLightBox()}}>x</button> }
      { (index != null) &&
        <div className="lightbox-image-container" ref={lightBoxRef}>
          { (index != 0) && <button className="nav-button prev-button" onClick={(e) => show(e, index-1)}>{leftOpenBigIcon}</button> }
          <img className="lightbox-img" src={imageToShow.image_full_size_url}></img>
          { (index != (props.images.length - 1)) && <button className="nav-button next-button" onClick={(e) => show(e, index+1)}>{rightOpenBigIcon}</button> }
        </div>
      }
    </div>
  )
}
